import { ClientIdentityType } from 'api/types/data';

export const isLegalClientRepresentative = (type: ClientIdentityType) =>
  type === ClientIdentityType.LegalClientRepresentative;
